<template>
  <div class="m-case">
    <!-- <img class="m-page-banner" src="../../assets/images/case_banner.jpg" alt=""> -->
    <div class="m-page-banner"></div>
    <div class="m-case-nav">
      <div @click="changeType(0)" class="case-nav-item" :class="currentTypeIndex===0?'case-nav-item-select':''">区域案例</div>
      <div @click="changeType(1)" class="case-nav-item" :class="currentTypeIndex===1?'case-nav-item-select':''">学校案例</div>
    </div>
    <div class="m-case-conent">
      <div class="case-item" v-for="(item, index) in currentList" :key="index">
        <div class="case-item-title">{{item.title}}</div>
        <img class="case-item-img" :src="item.imgUrl" alt="">
        <div class="case-item-content" :class="item.isExpand ? '' : 'unexpand-content'">{{item.content}}</div>
        <div class="item-expand-btn" @click="toggleItem(item)">{{item.isExpand ? '收起' : '展开'}}</div>
      </div>
    </div>
  </div>
</template>
<script>
import scrollreveal from 'scrollreveal'
export default {
  data() {
    return {
      currentTypeIndex: 0,
      currentList: [],
      areaCaseList: [{
        title: '广东省东莞市',
        imgUrl: require('../../assets/images/mImg/case/area_dg.png'),
        content: '为了解决区域教育均衡、优质发展的问题，响应东莞市委、市政府教育领域综合改革部署，2017年，东莞市教育局通过公开招标确定实施智慧教育方案，在教学体系搭建、平台运维、研训等方面推动东莞市“慧教育”项目开展。作为东莞市十大民生工程之一，本项目得到东莞市委市政府的充分肯定。项目实施以来，数字校园云平台已覆盖全东莞市近600所学校，近7万位教师，90多万名学生使用，并举办信息技术与教育教学融合创新的应用研训近500场次，已形成具有东莞特色的独特教育模式。',
        isExpand: false
      }, {
        title: '青海省西宁市',
        imgUrl: require('../../assets/images/mImg/case/area_xn.png'),
        content: '为缩小城乡间、学校间、教师间的差距，实现教育均衡、公平，2019年，西宁市在全国率先通过招商引资、购买服务方式，引进数字化教学平台，目前已实现全市133所中学、13万余中学生全覆盖。西宁市在教育信息化推进过程中遵循“顶层设计、统筹规划、以用促建、融合创新”的原则，突出建、管、用三个重点，先后投入2亿多资金实施网络改造维护、智慧课堂教学改革。',
        isExpand: false
      }, {
        title: '天津市宁河区',
        imgUrl: require('../../assets/images/mImg/case/area_tj.png'),
        content: '为深化信息技术在教育教学过程中的普遍应用，促进教育教学模式创新，2017年，天津市宁河区教育局通过公开招标，启动了天津市宁河区区域教育云平台与部分学校的智慧课堂建设项目。目前，该项目已覆盖天津市宁河区近百所学校，近5千位教师，6万多名学生使用。几年间，宁河区掀起了一股“课堂巧翻转，智慧促提升”的创新教学实践热潮，取得了良好的社会效应。教育云平台和智慧课堂的建设，重构了学习环境，优化了供给方式，创新了教学模式，重塑了教学评价方式。',
        isExpand: false
      }],
      schoolCaseList: [{
        title: '长沙市明德华兴中学',
        imgUrl: require('../../assets/images/mImg/case/school_mdhxzx.png'),
        content: '明德华兴中学是长沙市教育局直属优质公办学校，拥有近120年历史，是湖南省乃至全国基础教育的窗口学校。2014年，依据智慧校园建设规划，明德华兴中学引进在线教学平台，探索“翻转课堂”与明德华兴中学“三生课堂”的有机结合，共同打造以“明德树人”为核心思想的智慧课堂，提升教育教学质量，促进学生全面发展。智慧课堂开展以来，形成了独具华兴特色的信息化课堂。利用信息技术与课堂教学的深度融合，教师的教学实现了“以学定教”，学生的自主学习效率得到了提高。2019年，学校被认定为长沙市首批未来学校创建校，2020年，学校获评“2020年度网络学习空间应用普及活动优秀学校”。',
        isExpand: false
      }, {
        title: '西宁市第四高级中学',
        imgUrl: require('../../assets/images/mImg/case/school_xnsz.png'),
        content: '西宁市第四高级中学始建于1957年，是西宁市示范性（重点）高中。2021年开始全面推进智慧课堂教学工作，在市教育局的大力支持下，学校上下联动，认真落实每一项工作。一年多来，学校高ニ年级全体教师已将“前置任务、先学后教、以学定教、小组合作”等智慧课堂的理念贯穿于备课和授课等教学环节中，灵活运用智慧课堂“三翻二段十环节”的教学模式，结合数字化教育教学平台和平板电脑高效高质量授课；高一年级全体教师能将线上平台与智能终端相结合，极大地提高了学生自主探究学习的意识和能力。',
        isExpand: false
      }, {
        title: '西安市周至中学',
        imgUrl: require('../../assets/images/mImg/case/school_xazz.png'),
        content: '周至中学创立于1943年，是“陕西省示范高中”，学校始终坚持“以人为本、创新发展”的理念，紧扣“二曲故里、三秦名校”的目标，70余年来为国家培养了大批优秀人才。学校紧跟教育信息化的发展趋势，2019年9月，引进智慧课堂教学模式，使“互联网+教育”从理论转化为实际操作，开启了周至中学信息化教学的新天地。周至中学智慧课堂教学以信息化为支撑，形成“七步四核”的教育教学模式，迈出了创新的步伐。2019年以来，智慧班取得了显著的教育教学成果，学生整体进步率高达78.9%。信息技术水平的不断提升进一步激发了智慧课堂教学模式的生机与活力，信息化教学为教育均衡、教师成长、人才培养做出了很大贡献。',
        isExpand: false
      }, {
        title: '太原市第十一中学',
        imgUrl: require('../../assets/images/mImg/case/school_tysyzx.png'),
        content: '太原十一中是一所市属全日制公立完全中学，实行“三精”教育（小班化精品教学、军事化精细管理、人文化精心陪伴），构建“问学AI”翻转课堂模式（三问、两学、一AI）和“三体”育人生态系统（唤醒体育意识、赋予体育技能、弘扬体育精神）；全面实施全人教育。近年来，借助智慧课堂进行的“问学AI”课改取得了成效，师生现代化素养显著提升，多位教师在全国智慧课堂展示交流活动中作观摩课，学校被入选为中央电化教育馆在线教育应用创新项目学校，荣获了国际智慧教育展“智慧教育优秀示范校”、教育部“网络学习空间应用普及活动优秀学校”等荣誉称号，国家级课题《普通高中教学中有效应用信息技术的研究》成功结题。',
        isExpand: false
      }, {
        title: '新疆师范大学附属中学',
        imgUrl: require('../../assets/images/mImg//case/school_xjsdfz.png'),
        content: '新疆师范大学附属中学建于1984年，是全疆重点中学中办学历史最短，发展速度最快，以管理科学和质量突出而享誉全疆的知名中学，隶属自治区教育厅，由新疆师范大学直接管理。2020年9月，新疆师范大学附属中学开始进行智慧课堂教学试点工作，旨在探索实现信息技术与学科教学的深度融合，助力学生和教师共同成长。2020年11月学校被中央电教馆确定为在线教育创新项目学校，2021年1月申报中央电化教育馆课题“信息技术与学科教学融合策略研究”获得正式立项，2021年9月学校成为新疆地方上唯一一所在中央电化教育馆在线教育应用创新典型案例名单中的学校。通过智慧课堂试点实践，提高了教师信息化水平、提升了学生学习主动性、创新了学校教研方式、提高了课堂教学质量、尊重学生差异化等。2022年3月申报自治区教育科学优秀成果“信息技术与学科教学融合策略研究”。',
        isExpand: false
      }, {
        title: '海口市第九中学',
        imgUrl: require('../../assets/images/mImg/case/school_hkjz.png'),
        content: '海口市第九中学创办于1958年，坚持以“立德树人”为教育根本任务；恪守“为每位师生的卓越发展服务”的办学理念；以“出优秀学生，出优秀教师，出先进办学经验”为办学目标，努力培养“全面发展、自主向上”的学生；弘扬“尚礼、博学、严谨、和谐”的校风和“勤奋、互助、坚毅、向上”的学风。根据新时期的教育发展要求，立足于学生的可持续发展，海口九中不断更新教学理念，创新教学模式及管理方法，着力研究平行分班背景下的有效课堂教学方法和模式，把“互联网+”引进校园，鼓励教师依托各种先进信息化技术开展教学活动，形成了“三翻三步五环节”翻转课堂教学模式。努力打造人文校园、绿色校园、智慧校园，走出一条适合学生全面健康发展的道路。海口市第九中学，因其丰厚的办学业绩，高质量的育人成果，学生幸福成长，教师快乐工作，校园一片生机，多姿多彩。',
        isExpand: false
      }, {
        title: '泉州市奕聪中学',
        imgUrl: require('../../assets/images/mImg/case/school_qzyc.png'),
        content: '泉州市奕聪中学（原罗溪中学）创办于1957年，系爱国侨胞、印尼金光集团创办人黄奕聪先生捐资创建的公办侨助完全中学，在校学生2258人。办学以来，学校大力弘扬“勤劳、诚实、善予、合作”的奕聪精神，坚持“以人为本，和谐发展”的办学理念，坚持“科技创新，体艺见长”的办学特色，中高考成绩稳居洛江区前列，先后荣获全国教科研先进单位、泉州市高中课改基地校等46项国家、省、市级荣誉。2021年5月，黄奕聪慈善基金会引进“智慧课堂”项目，全面借助信息技术手段，构建数字化教学环境。合作以来，通过推进“智慧课堂”，创新教学模式，构建高效课堂，促进教师成长；通过自主探究合作的学习方式，激发学生的学习潜力，培养学生综合能力，全面提高教学质量。',
        isExpand: false
      }, {
        title: '恩施市英才学校',
        imgUrl: require('../../assets/images/mImg/case/school_esyc.png'),
        content: '为适应现代教育信息化发展，有效提高课堂效率，恩施市英才学校率先打破传统教学，于2017年开始建立“数字校园基地”，引进“爱学派智慧课堂”，开启了“互联网+”课堂教学改革，全面提升学生核心素养，成为恩施州第一家引进平板教学的民办学校。经过全面深化的课堂改革，现已全面覆盖初高中60个班，形成了“智慧课堂”的课堂教学模式，利用工具和平台去学习、体验、交流、探索、创造，真切体会到学习过程是有趣的、有价值的。智慧课堂的深入研究、积极尝试、敢于创新，也为教师专业成长提供了养分，更是英才人进德修业、追求卓越的职业精神和素养的体现，也坚定了学校以特色英才模式培育世纪英才的愿景。',
        isExpand: false
      }]
    }
  },
  created() {
    this.changeType(0)
  },
  mounted() {
    this.$nextTick(() => {
      let that = this
      setTimeout(() => {
        that.setAnimation()
      }, 100)
    })
  },
  methods: {
    changeType(index) {
      this.currentTypeIndex = index
      if (index == 0) {
        this.currentList = this.areaCaseList
      } else {
        this.currentList = this.schoolCaseList
      }
      this.setAnimation()
    },
    toggleItem(item) {
      item.isExpand = !item.isExpand
      this.setAnimation()
    },
    // 动画
    setAnimation() {
      scrollreveal().reveal('.m-case .case-item', {
        duration: 1500,
        origin: 'bottom',
        reset: true,
        mobile: true,
        distance: '40px',
        easing: 'ease-in-out'
      });
    }
  }
}
</script>
<style lang="scss" scoped>
.m-case {
  width: 100%;
  .m-page-banner {
    width: 100%;
    display: block;
    height: 4.5rem;
    background: url('../../assets/images/case_banner.jpg') no-repeat;
    background-position: center top;
    background-size: cover;
  }
  .m-case-nav {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-around;
    font-size: .33rem;
    font-weight: 500;
    color: #B5B5B6;
    line-height: .33rem;
    margin-top: .66rem;
    .case-nav-item {
      padding-bottom: .1rem;
      border-bottom: 2px solid transparent;
    }
    .case-nav-item-select {
      color: #3E3A39;
      border-bottom: 2px solid #217CFE;
    }
  }
  .m-case-conent {
    width: 100%;
    margin-bottom: 1.7rem;
    .case-item {
      position: relative;
      width: 6.5rem;
      background: #FFFFFF;
      box-shadow: .11rem .14rem .38rem .2rem rgba(61, 61, 61, 0.2);
      border-radius: .1rem;
      margin: 0 auto;
      margin-top: .5rem;
      padding: .42rem .34rem .86rem;
      .case-item-title {
        height: .36rem;
        font-size: .38rem;
        font-weight: 600;
        color: #393332;
        line-height: .36rem;
        border-left: .09rem solid #217CFE;
        padding-left: .16rem;
      }
      .case-item-img {
        width: 100%;
        display: block;
        margin-top: .3rem;
        margin-bottom: .4rem;
      }
      .case-item-content {
        font-size: .29rem;
        font-weight: 400;
        color: #595757;
        line-height: .5rem;
      }
      .unexpand-content {
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
      }
      .item-expand-btn {
        position: absolute;
        right: .36rem;
        bottom: .36rem;
        font-size: .25rem;
        font-weight: 400;
        color: #217CFE;
      }
    }
  }
}
</style>